/* eslint-disable */
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const numbersRegex = /[0-9]+/;
export const invalidSymbolsRegex = /^(\+7|7|8)|[^\d]/g;
export const lettersRegex = /[a-zA-Z]+/g;
export const whitespaceRegex = /\s/;
export const unicodeRegex = /[^\u0000-\u007F]+/g;
export const phoneRegex = /^(\+7|7|8)?(\s|\-)?\(?([0-9]{3})\)?(\s|\-)?([0-9]{3})(\s|\-)?([0-9]{2})(\s|\-)?([0-9]{2})/;
/* eslint-enable */
